import { render } from "./CtaSection.vue?vue&type=template&id=23a64968&scoped=true"
const script = {}

import "./CtaSection.vue?vue&type=style&index=0&id=23a64968&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23a64968"]])

export default __exports__